<app-auth-layout>
  <img class="logo" src="./assets/images/logo.svg" />

  <app-error *ngIf="errCode" [errcode]="errCode" />

  <h1>Your account is on hold.</h1>
  
  <div *ngIf="isChild">
    <p>
     Contact your teams admin for future assistance.
    </p>
         <sync-button
      label="Back to sign in"
      [leadAdornment]="true"
      leadIconAdornment="arrow-left"
      [onClick]="onClickBackToSignIn"
    />
  </div>  
  <div *ngIf="!isChild"> 
    <p>We were not able to automatically renew your account. You’ll need to renew your account to get syncing again.</p>

    <sync-button 
      label="Renew my account"
      [onClick]="onClickRenew"
      [isLoading]="isLoading"
    />

    <sync-divider />
    <p>Need help? <a href="https://help.sync.com/hc/en-us/requests/new?ticket_form_id=39041883966483" target="_blank">Contact Sync customer service.</a></p>
  </div>
</app-auth-layout>